import {ins as axios} from './axios'
import Version from '@/version'
import firebase from 'firebase/app'
import 'firebase/firebase-messaging'
export const firebaseModule = {
  state: {
    fbApp: null,
    firebaseToken: null,
    notificationPermission: false
  },
  getters: {
    notificationPermission: state => {
      return state.notificationPermission
    }
  },
  mutations: {
    firebaseToken (state, payload) {
      state.firebaseToken = payload
    },
    fbApp (state, payload) {
      if (payload === null) state.fbApp.delete()
      state.fbApp = payload
    },
    notificationPermission (state, payload) {
      state.notificationPermission = payload === 'granted'
    }
  },
  actions: {
    firebaseInit (context, payload) {
      const sendTokenToServer = async (token) => {
        context.commit('firebaseToken', token)
        try {
          await axios({
            url: `/info/firebase-token`,
            method: 'patch',
            data: {token},
            headers: {
              'Authorization': `Bearer ${this.getters.accessToken}`,
              'Panel-Hub-Version': Version
            }
          })
        } catch (e) {
          console.log(e)
        }
      }
      const eventBind = (messaging) => {
        messaging.onMessage(_payload => {
          const {data} = _payload
          if (data && data.message) {
            const rec = JSON.parse(data.message)
            const {from, to, message, type, url, date, roomID} = rec
            context.commit('currentMessage', {
              from,
              to,
              message,
              type,
              url,
              date,
              roomID
            })
          }
        })

        messaging.onTokenRefresh(async () => {
          const refreshToken = await messaging.getToken()
          await sendTokenToServer(refreshToken)
        })
      }
      return new Promise(async (resolve, reject) => {
        if (!this.getters.accessToken) return reject(new Error('access Token invalid'))
        if (!this.getters.notificationPermission) return resolve(false)
        try {
          if (!('serviceWorker' in navigator)) return reject(new Error('service work not support.'))
          const {data} = await axios({
            url: `/info/firebase-info`,
            method: 'get',
            headers: {
              'Authorization': `Bearer ${this.getters.accessToken}`,
              'Panel-Hub-Version': Version
            }
          })
          const {publicKey, messagingSenderId, userBackgroundImage} = data
          if (userBackgroundImage) {
            context.commit('userBackgroundImage', userBackgroundImage)
          }
          try {
            const exists = firebase.apps.length
            const app = exists ? firebase.app() : firebase.initializeApp({messagingSenderId})
            console.log(app)
            // context.commit('fbApp', app)
            const messaging = firebase.messaging()
            const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')
            if (!exists) {
              messaging.useServiceWorker(registration)
              await messaging.usePublicVapidKey(publicKey)
              eventBind(messaging)
            }
            const token = await messaging.getToken()
            await sendTokenToServer(token)
          } catch (e) {
            console.log(e)
          }
          // EVENT BINDING
          return resolve(true)
        } catch (e) {
          console.error(e)
          return resolve(true)
        }
      })
    },
    requestPermission (context, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const result = await Notification.requestPermission()
          await context.commit('notificationPermission', result)
          return resolve(true)
        } catch (e) {
          await context.commit('notificationPermission', false)
          return resolve(false)
        }
      })
    },
    firebaseSend (context, payload) {
      return new Promise(async (resolve, reject) => {
        const {from, to, message, type, url} = payload
        const {data} = await axios({
          url: `/info/firebase-messaging`,
          method: 'put',
          data: {from, to, message, type, url},
          headers: {
            'Authorization': `Bearer ${this.getters.accessToken}`,
            'Panel-Hub-Version': Version
          }
        })
        console.log(data)
        return resolve()
      })
    },
    firebaseLogout (context) {
      // if (context.getters.fbApp) context.commit('fbApp', null)
      // context.commit('firebaseToken', null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/firebase.store.js